import React from 'react';
import { Grid } from "@mui/material";
import discord from "../../Images/discord.png";
import discover from "../../Images/discover_new.png";
import dribble from "../../Images/Dribbble_Text_Logo_new.png";
import dropbox from "../../Images/Dropbox_Logo_new.png";
import airnb from "../../Images/Airbnb_Logo_Belo_new.png";
import capitalone from "../../Images/capitalone.png";
import Shipbob from "../../Images/Shipbob.png"
import Slack from "../../Images/slack.png"
import Walmart from "../../Images/walmart_logo_new.png"

import "./style.css"

export default function Adswiper() {
    const logos = [
      { src: discord, alt: "Discord" },
      { src: capitalone, alt: "Capital One" },
      { src: dribble, alt: "Dribble" },
      { src: dropbox, alt: "Dropbox" },
      { src: airnb, alt: "Airbnb" },
      { src: discover, alt: "Discover" },
      { src: Shipbob, alt: "Shipbob" },
      { src: Slack, alt: "Slack" },
      { src: Walmart, alt: "Walmart" },
    ];
    const scrollingLogos = [...logos, ...logos];

    return (
      <Grid xs={12} mt={0} mb={0}>
        <div className="logo-carousel" aria-label="Featured companies">
          <div className="logo-carousel-track">
            {scrollingLogos.map((logo, index) => (
              <div className="logo-carousel-slide" key={`${logo.alt}-${index}`}>
                <img src={logo.src} alt={logo.alt} className="responsive-image" />
              </div>
            ))}
          </div>
        </div>
      </Grid>
    );
}
